import { useEffect, useRef, useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { GoAlertFill } from "react-icons/go";
import md5 from "md5";
import { CommonAxiosGet, CommonAxiosPostLogin } from "./CommonUtils/CommonAxios";
import { config } from "./CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { ErrorMessage, Field, FormikProvider, useFormik, Form } from "formik";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";
import axios from "axios";
import { getTokenExpiry } from "./CommonUtils/TimeUtility";

function LoginPage() {
    const validationSchema = Yup.object({
        username: Yup.string().required("User Name is required").nullable(),
        password: Yup.string().required("Password is required").nullable(),
        captcha: Yup.string().required("Captcha is required").nullable(),
    });
    const hasFetchedData = useRef(false);

    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const [error, setError] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [captcha, setCaptcha] = useState(null);
    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            captcha: "",
        },
        validationSchema,
        onSubmit: (values, { setSubmitting, setFieldValue }) => {
            const body = {
                userId: values.username,
                userPassword: md5(values.password),
                captcha: values.captcha,
                captchaId: captchaInput,
                loginType: "aprusa",
            };
            CommonAxiosPostLogin(config.url.API_URL + "auth/authenticate", body).then((response) => {
                if (response?.data?.responseCode === "01") {

                    var decodedToken = jwtDecode(response?.data?.accessToken);

                    const tokenExpiry = getTokenExpiry(response.data.accessToken);
                    const refreshExpiry = getTokenExpiry(response.data.refreshToken);

                    Cookies.set("token", response?.data?.accessToken); //, { expires: accessTokenTime }
                    Cookies.set("refreshToken", response?.data?.refreshToken); //, { expires: rfTokenTime }
                    Cookies.set("tokenTime", tokenExpiry);
                    Cookies.set("refreshTokenTime", refreshExpiry);

                    // Store user info
                    sessionStorage.setItem("user_id", decodedToken?.user_id);
                    sessionStorage.setItem("is_changed", decodedToken?.is_changed);
                    sessionStorage.setItem("role_id", decodedToken?.role_id);
                    sessionStorage.setItem("user_name", decodedToken?.user_name);

                    // Load menu
                    CommonAxiosGet(config.url.API_URL + "getServices").then((res) => {

                        if (res?.data?.scode === "01") {

                            sessionStorage.setItem("menuData", JSON.stringify(res.data.services));
                            navigate("/RusaDashboard");

                        }
                    });
                }
                else {
                    Swal.fire({
                        text: response?.data?.sdesc,
                        icon: "error",
                        confirmButtonText: "OK",
                        backdrop: false,
                    }).then(() => {

                        if (response?.data?.sdesc === "Invalid Captcha") {
                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }

                        if (
                            response?.data?.sdesc === "Invalid login credentials! Try again." ||
                            response?.data?.sdesc === "Please Check  type of College"
                        ) {
                            setFieldValue("username", "");
                            setFieldValue("password", "");
                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                    });
                }
                setSubmitting(false);
            });
        },
    });

    function GetCaptcha() {
        let url = config.url.API_URL + `captcha `;
        axios.get(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCaptcha(res?.data?.sdesc)
                setCaptchaInput(res?.data?.captchaId)

            } else {
                setCaptcha('')
                setCaptchaInput('')
            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetCaptcha();
            hasFetchedData.current = true
        }
    }, [])


    return (
        <>

            <Container fluid className="px-0">
                <div className="parent-wholediv">
                    <Row className="mx-0 login-row-left">
                        <Col xs={16} sm={16} lg={6} md={12} xl={6} xxl={6} className="px-0 parent-loginleftpart">
                            <div className="parlogin-left">
                                <img src="../images/loginleft-img.webp" alt="" className="img-fluid" />
                                <div className="login-imgtext">
                                    <p className="mb-0">Andhra Pradesh RUSA (Rashtriya Uchchatar Shiksha Abhiyan) is the state-level implementation of the national RUSA scheme, aimed at strengthening higher education institutions across Andhra Pradesh.
                                        Under Andhra Pradesh Rashtriya Uchchatar Shiksha Abhiyan, the Government of Andhra Pradesh works to improve the quality, access, equity, and governance of state universities and colleges. The programme supports infrastructure development, modernization of classrooms and laboratories, digital learning initiatives, faculty development, research and innovation, accreditation (NAAC/NIRF), and academic reforms.</p>
                                </div>
                            </div>
                        </Col>
                        <Col xs={16} sm={16} lg={6} md={12} xl={6} xxl={6} className="parent-loginrightpart">
                            <div className="parlogin-right">
                                <div className="par-logopart">
                                    <img src="../images/ap-logo.webp" alt="" className="img-fluid" />
                                    <div className="paralogo-text">
                                        <p className="mb-0  ">State Project Directorate  Rashtriya Uchchatar Shiksha Abhiyan (RUSA) </p>
                                        {/* <p className="mb-0">Rashtriya Uchchatar Shiksha Abhiyan (RUSA)    </p> */}

                                        <h6>Higher Education Department
                                            Government of Andhra Pradesh</h6>
                                    </div>

                                    <img src="../images/rusa-logo.webp" alt="" className="img-fluid rusa-logo" />
                                </div>
                                <div className="paralogin-block">
                                    <div className="login-blockhead">
                                        <h5 className="">Login</h5>
                                    </div>
                                    <div className="paralogin-form">
                                        {error && (
                                            <Alert variant="danger">
                                                <GoAlertFill size={27} /> {error}
                                            </Alert>
                                        )}
                                        <FormikProvider value={formik}>
                                            <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
                                                {/* <div className="mb-2">
                                                    <label>User Name</label>

                                                    <Field
                                                        name="username"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="12"
                                                        autoComplete="new-password"
                                                        autoCorrect="off"
                                                    />
                                                    <ErrorMessage name="username" component="div" className="text-danger" />
                                                </div>

                                                <div className="mb-3">
                                                    <label>Password</label>

                                                    <div style={{ position: "relative" }}>

                                                        <Field
                                                            name="password"
                                                            type={showPassword ? "text" : "password"}
                                                            maxLength="15"
                                                            className="form-control"
                                                            style={{ paddingRight: "40px" }}   // space for eye icon
                                                        />

                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    setShowPassword(!showPassword);
                                                                }
                                                            }}
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                                userSelect: "none",
                                                            }}
                                                        >
                                                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                                                        </span>


                                                    </div>

                                                    <ErrorMessage
                                                        name="password"
                                                        component="div"
                                                        className="text-danger"
                                                    />
                                                </div> */}




                                                <div className="mb-3">
                                                    <label>User Name</label>
                                                    <div style={{ position: "relative" }}>

                                                        <i className="fa-solid fa-user" style={{
                                                            position: "absolute",
                                                            left: "12px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            color: "#999"
                                                        }}></i>

                                                        <Field
                                                            name="username"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="12"
                                                            autoComplete="new-password"
                                                            autoCorrect="off"
                                                            style={{ paddingLeft: "35px" }}
                                                        />
                                                    </div>
                                                    <ErrorMessage name="username" component="div" className="text-danger" />
                                                </div>


                                                {/* Password */}
                                                <div className="mb-3">
                                                    <label>Password</label>

                                                    <div style={{ position: "relative" }}>
                                                        {/* Lock Icon */}
                                                        <i
                                                            className="fas fa-lock"
                                                            style={{
                                                                position: "absolute",
                                                                left: "12px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#999"
                                                            }}
                                                        ></i>

                                                        {/* Eye Icon */}
                                                        <i
                                                            className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    setShowPassword(!showPassword);
                                                                }
                                                            }}
                                                            role="button"
                                                            style={{
                                                                position: "absolute",
                                                                right: "12px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                                color: "#999"
                                                            }}
                                                        ></i>

                                                        <Field
                                                            name="password"
                                                            type={showPassword ? "text" : "password"}
                                                            maxLength="15"
                                                            className="form-control"
                                                            style={{
                                                                paddingLeft: "35px",
                                                                paddingRight: "40px"
                                                            }}
                                                        />
                                                    </div>

                                                    <ErrorMessage name="password" component="div" className="text-danger" />
                                                </div>



                                                <div className="mb-3">
                                                    <label>Captcha</label>
                                                    <div className="d-flex gap-2">
                                                        <Field
                                                            name="captcha"
                                                            type="text"
                                                            maxLength="5"
                                                            className="form-control"
                                                        />


                                                        <div
                                                            style={{
                                                                background: "#f0f0f0",
                                                                padding: "8px 12px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "3px",
                                                                userSelect: "none",
                                                            }}
                                                        >
                                                            {captcha && (
                                                                <img src={captcha} alt="Captcha" width="100%" height="100%" />
                                                            )}
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={GetCaptcha}
                                                        >
                                                            ↻
                                                        </button>
                                                    </div>
                                                    <ErrorMessage name="captcha" component="div" className="text-danger" />
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn login-btn w-100"
                                                >
                                                    Login
                                                </button>

                                                <div className="forgot-div">
                                                    <a href="/ForgotPassword">Forgot Password?</a>
                                                </div>

                                            </Form>
                                        </FormikProvider>

                                    </div>
                                </div>
                                <div className="login-footer text-center">
                                    <div className="footer-div">
                                        <p>Designed and Developed by <a href="https://apcfss.in/"><img src="../images/footer-logo.svg" alt="" className="img-fluid" /></a></p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );

}
export default LoginPage;